export default {
  name: 'GcFullImage',
  props: {
    imageSmallUrl: {
      type: String,
      required: true,
    },
    imageMediumUrl: {
      type: String,
      required: true,
    },
    imageLargeUrl: {
      type: String,
      required: true,
    },
    imageAltText: {
      type: String,
      required: true,
    },
  },
};
